export const currencyPairs = [
  {
    label: 'EURUSD',
    value: 'EURUSD',
  },
  {
    label: 'EURGBP',
    value: 'EURGBP',
  },
  {
    label: 'GBPUSD',
    value: 'GBPUSD',
  },
  {
    label: 'USDJPY',
    value: 'USDJPY',
  },
  {
    label: 'AUDUSD',
    value: 'AUDUSD',
  },
  {
    label: 'USDCHF',
    value: 'USDCHF',
  },
  {
    label: 'NZDUSD',
    value: 'NZDUSD',
  },
  {
    label: 'USDCAD',
    value: 'USDCAD',
  },
  {
    label: 'USDZAR',
    value: 'USDZAR',
  },
];

export const majorCurrencies = [
  {
    label: 'USD',
    value: 'USD',
  },
  {
    label: 'EUR',
    value: 'EUR',
  },
  {
    label: 'GBP',
    value: 'GBP',
  },
  {
    label: 'JPY',
    value: 'JPY',
  },
  {
    label: 'AUD',
    value: 'AUD',
  },
  {
    label: 'CHF',
    value: 'CHF',
  },
  {
    label: 'NZD',
    value: 'NZD',
  },
  {
    label: 'CAD',
    value: 'CAD',
  },
  {
    label: 'ZAR',
    value: 'ZAR',
  },
];
